const vendas = [

  // TITAN
  {
    id: "titan-gold-wraps",
    category: "vendas",
    slug: "vendas-titan-gold",
    name: "Vendas Titan Gold",
    brand: "TITAN",
    variants: [
      { length: "2m", image: "/Productos/ven-tit-g.jpg", price: 140 },
      { length: "2.5m", image: "/Productos/ven-tit-g.jpg", price: 145 },
      { length: "3m", image: "/Productos/ven-tit-g.jpg", price: 150 },
    ],
  },
  {
    id: "titan-thp-wraps",
    category: "vendas",
    slug: "vendas-titan-thp",
    name: "Vendas Titan THP",
    brand: "TITAN",
    variants: [
      { length: "2m", image: "/Productos/ven-tit-thp.webp", price: 140 },
      { length: "2.5m", image: "/Productos/ven-tit-thp.webp", price: 145 },
      { length: "3m", image: "/Productos/ven-tit-thp.webp", price: 150 },
    ],
  },

  // PIONEER
  {
    id: "pioneer-heavy-wraps",
    category: "vendas",
    slug: "vendas-pioneer-heavy",
    name: "Vendas Pioneer Heavy",
    brand: "PIONEER",
    variants: [
      { length: "2m", image: "/Productos/ven-pio-hea.webp", price: 150 },
      { length: "2.5m", image: "/Productos/ven-pio-hea.webp", price: 150 },
      { length: "3m", image: "/Productos/ven-pio-hea.webp", price: 150 },
    ],
  },
  {
    id: "pioneer-medium-wraps",
    category: "vendas",
    slug: "vendas-pioneer-medium",
    name: "Vendas Pioneer Medium",
    brand: "PIONEER",
    variants: [
      { length: "2m", image: "/Productos/ven-pio-med.webp", price: 145 },
      { length: "2.5m", image: "/Productos/ven-pio-med.webp", price: 145 },
      { length: "3m", image: "/Productos/ven-pio-med.webp", price: 145 },
    ],
  },
  {
    id: "pioneer-light-wraps",
    category: "vendas",
    slug: "vendas-pioneer-light",
    name: "Vendas Pioneer Light",
    brand: "PIONEER",
    variants: [
      { length: "2m", image: "/Productos/ven-pio-lig.webp", price: 140 },
      { length: "2.5m", image: "/Productos/ven-pio-lig.webp", price: 140 },
      { length: "3m", image: "/Productos/ven-pio-lig.webp", price: 140 },
    ],
  },
  {
    id: "pioneer-commander-wraps",
    category: "vendas",
    slug: "vendas-pioneer-commander",
    name: "Vendas Pioneer Commander",
    brand: "PIONEER",
    variants: [
      { length: "2m", image: "/Productos/ven-pio-com.jpg", price: 145 },
      { length: "2.5m", image: "/Productos/ven-pio-com.jpg", price: 145 },
      { length: "3m", image: "/Productos/ven-pio-com.jpg", price: 145 },
    ],
  },
  {
    id: "pioneer-guardian-wraps",
    category: "vendas",
    slug: "vendas-pioneer-guardian",
    name: "Vendas Pioneer Guardian",
    brand: "PIONEER",
    variants: [
      { length: "2m", image: "/Productos/ven-pio-gua.jpg", price: 130 },
      { length: "2.5m", image: "/Productos/ven-pio-gua.jpg", price: 130 },
      { length: "3m", image: "/Productos/ven-pio-gua.jpg", price: 130 },
    ],
  },

  // SBD
  {
    id: "sbd-wraps",
    category: "vendas",
    slug: "vendas-sbd",
    name: "Vendas SBD",
    brand: "SBD",
    variants: [
      { length: "2.5m", image: "/Productos/vendas-sbd.webp", price: 155 },
    ],
  },

  // INZER
  {
    id: "inzer-atomic-wraps",
    category: "vendas",
    slug: "vendas-inzer-atomic",
    name: "Vendas Inzer Atomic",
    brand: "INZER",
    variants: [
      { length: "2m", image: "/Productos/ven-inz-ato.webp", price: 128 },
      { length: "2.5m", image: "/Productos/ven-inz-ato.webp", price: 140 },
      { length: "3m", image: "/Productos/ven-inz-ato.webp", price: 152 },
    ],
  },
  {
    id: "inzer-gripper-wraps",
    category: "vendas",
    slug: "vendas-inzer-gripper",
    name: "Vendas Inzer Gripper",
    brand: "INZER",
    variants: [
      { length: "2m", image: "/Productos/ven-inz-gri.webp", price: 112 },
      { length: "2.5m", image: "/Productos/ven-inz-gri.webp", price: 120 },
      { length: "3m", image: "/Productos/ven-inz-gri.webp", price: 128 },
    ],
  },
  {
    id: "inzer-black-beauty-wraps",
    category: "vendas",
    slug: "vendas-inzer-black-beauty",
    name: "Vendas Inzer Black Beauty",
    brand: "INZER",
    variants: [
      { length: "2m", image: "/Productos/ven-inz-bb.webp", price: 152 },
      { length: "2.5m", image: "/Productos/ven-inz-bb.webp", price: 170 },
      { length: "3m", image: "/Productos/ven-inz-bb.webp", price: 187 },
    ],
  },
  {
    id: "inzer-iron-wraps",
    category: "vendas",
    slug: "vendas-inzer-iron",
    name: "Vendas Inzer Iron",
    brand: "INZER",
    variants: [
      { length: "2m", image: "/Productos/ven-inz-iro.webp", price: 95 },
      { length: "2.5m", image: "/Productos/ven-inz-iro.webp", price: 98},
    ],
  },

];

export default vendas;
